"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var findFolderOperation_1 = require("owa-service/lib/operation/findFolderOperation");
var findFolderRequest_1 = require("owa-service/lib/factory/findFolderRequest");
var folderId_1 = require("owa-service/lib/factory/folderId");
var folderResponseShape_1 = require("owa-service/lib/factory/folderResponseShape");
var propertyUri_1 = require("owa-service/lib/factory/propertyUri");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
function configureRequestBody(rootFolderId) {
    return findFolderRequest_1.default({
        FolderShape: folderResponseShape_1.default({
            BaseShape: 'IdOnly',
            AdditionalProperties: [
                propertyUri_1.default({ FieldURI: 'DistinguishedFolderId' }),
                propertyUri_1.default({ FieldURI: 'FolderClass' }),
                propertyUri_1.default({ FieldURI: 'FolderDisplayName' }),
                propertyUri_1.default({ FieldURI: 'ParentFolderId' }),
            ],
        }),
        Paging: null,
        ParentFolderIds: [folderId_1.default({ Id: rootFolderId })],
        ReturnParentFolder: true,
        ShapeName: 'Folder',
        Traversal: 'Deep',
    });
}
function findFolders(rootFolderId) {
    var requestBody = configureRequestBody(rootFolderId);
    return findFolderOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = findFolders;
//# sourceMappingURL=findFoldersService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/services/findFoldersService.js
// module id = 5223
// module chunks = 2